import { apiSlice } from './apiSlice';
const USERS_URL = '/api/users';

export const usersAdminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllUsers: builder.query({
      query: () => ({
        url: `${USERS_URL}/admin`,
        method: 'GET',
      }),
      providesTags: ['Users'],
    }),
    updateUserAdminRecord: builder.mutation({
      query: ({ userId, ...body }) => ({
        url: `${USERS_URL}/${userId}/admin-records`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Users'],
    }),
    deleteUser: builder.mutation({
      query: (userId) => ({
        url: `${USERS_URL}/${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Users'],
    }),
    createTestUsers: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/test-users`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Users'],
    }),
    toggleAdminStatus: builder.mutation({
      query: ({ userId, isAdmin }) => ({
        url: `${USERS_URL}/${userId}/admin-status`,
        method: 'PATCH',
        body: { isAdmin },
      }),
      invalidatesTags: ['Users'],
    }),
    toggleAdFreeStatus: builder.mutation({
      query: ({ userId, adFree }) => ({
        url: `${USERS_URL}/${userId}/ad-free-status`,
        method: 'PATCH',
        body: { adFree },
      }),
      invalidatesTags: ['Users'],
    }),
    createDraftBotLeague: builder.mutation({
      query: () => ({
        url: '/api/testing/draft-bot-league',
        method: 'POST',
      }),
      invalidatesTags: ['Users', 'Leagues'],
    }),
    resetLeagueDraft: builder.mutation({
      query: (leagueId) => ({
        url: `/api/draft/league/${leagueId}/reset`,
        method: 'POST',
      }),
      invalidatesTags: ['Leagues', 'Drafts'],
    }),
  }),
});

export const {
  useGetAllUsersQuery,
  useUpdateUserAdminRecordMutation,
  useDeleteUserMutation,
  useCreateTestUsersMutation,
  useToggleAdminStatusMutation,
  useToggleAdFreeStatusMutation,
  useCreateDraftBotLeagueMutation,
  useResetLeagueDraftMutation,
} = usersAdminApiSlice;
